import React from 'react';

import { List, Text, useMantineTheme } from '@mantine/core';

interface SummaryItemListProps {
  summaryItems?: string[];
  emptyMessage: string;
}

export function SummaryItemList({ summaryItems, emptyMessage }: SummaryItemListProps) {
  const theme = useMantineTheme();

  if (!summaryItems || summaryItems.length === 0) {
    return (
      <Text size="sm" color={theme.colors.gray[7]}>
        {emptyMessage}
      </Text>
    );
  }

  return (
    <List>
      {summaryItems.map((summaryItem, summaryItemIndex) => (
        <List.Item key={summaryItemIndex}>
          <Text size="md" color={theme.colors.gray[7]}>
            {summaryItem}
          </Text>
        </List.Item>
      ))}
    </List>
  );
}
